import { combineReducers } from 'redux';
import userReducer from './Reducers/userReducer';
import goodsReducer from './Reducers/goodsReducer';
import shopReducer from './Reducers/shopReducer';

const rootReducer = combineReducers({
    user: userReducer,
    goods: goodsReducer,
    shop: shopReducer,
});

export default rootReducer;